<template>
  <div :class="{
    'input--invalid': shouldShowValidationError(),
    'input--required': required,
    'input--disabled': disabled
  }">

    <input-label-full-width
      :label="label"
      :required="required">
    </input-label-full-width>

    <div class="input--dob-select">
        <input type="number" ref="dayElm" :disabled="disabled" placeholder="DD" v-model="day" v-on:keydown="keydownDay" v-on:input="inputDay" v-on:focus="focusDay" v-on:blur="blurDay" min="1" max="31" pattern="\d*">
        <span class="separator">/</span>
        <input type="number" ref="monthElm" :disabled="disabled" placeholder="MM" v-model="month" v-on:keydown="keydownMonth" v-on:input="inputMonth" v-on:focus="focusMonth" v-on:blur="blurMonth" min="1" max="12" pattern="\d*">
        <span class="separator">/</span>
        <input type="number" ref="yearElm" :disabled="disabled" placeholder="YYYY" v-model="year" v-on:keydown="keydownYear" v-on:input="inputYear" v-on:focus="focusYear" v-on:blur="blurYear" min="1900" :max="currentYear" pattern="\d*">
    </div>

    <div v-if="shouldShowValidationError() || overrideShowError" class="input__validation-error-msg">
      {{ failureMsg }}
    </div>

  </div>
</template>
<script>
  import inputLabelFullWidth from './inputLabelFullWidth'

  export default {
    name: 'dobSelection',
    props: [
      'required',
      'label',
      'value',
      'disabled',
      'failureMsg'
    ],
    components: {
      inputLabelFullWidth
    },
    data () {
      return {
        currentYear: new Date().getFullYear(),
        day: '',
        month: '',
        year: '',
        showError: false,
        initiated: {
          day: false,
          month: false,
          year: false
        },
        overrideShowError: false
      }
    },
    methods: {
      focusDay () {
        setTimeout(() => {
          this.$refs.dayElm.select()
        }, 10)
      },
      focusMonth () {
        setTimeout(() => {
          this.$refs.monthElm.select()
        }, 10)
      },
      focusYear () {
        setTimeout(() => {
          this.$refs.yearElm.select()
        }, 10)
      },
      blur () {
        // this.$nextTick(() => {
        //   this.$parent.$el.scrollIntoView()
        // })
      },
      blurDay () {
        if (this.isFieldValid('day')) {
          this.day = this.addLeadingZeros(this.day, 2)
        }
        this.initiated.day = true
        this.blur()
      },
      blurMonth () {
        if (this.isFieldValid('month')) {
          this.month = this.addLeadingZeros(this.month, 2)
        }
        this.initiated.month = true
        this.blur()
      },
      blurYear () {
        // TODO: This is very Y2K bug-esque.
        if (this.year.length === 2) {
          this.year = '19' + this.year
        }
        this.initiated.year = true
        this.blur()
      },
      isFieldValid (field) {
        switch (field) {
          case 'day':
            return this.day !== '' && this.day >= 1 && this.day <= 31
          case 'month':
            return this.month !== '' && this.month >= 1 && this.month <= 12
          case 'year':
            return this.year !== '' && this.year >= 1900 && this.year <= this.currentYear
        }
        return false
      },
      addLeadingZeros (field, length) {
        let s = field + ''
        while (s.length < length) {
          s = '0' + s
        }

        return s
      },
      isRadioButton () {
        return false
      },
      getValue () {
        if (this.year === '' || this.month === '' || this.day === '') {
          return null
        }

        return this.year + '-' + this.month + '-' + this.day
      },
      shouldShowValidationError () {
        return !this.isValid() && (this.showError || this.allFieldsInitiated())
      },
      highlightError () {
        this.showError = true
      },
      allFieldsInitiated () {
        if (this.initiated.day && this.initiated.month && this.initiated.year) {
          this.showError = true
          return true
        }

        return false
      },

      isValid () {
        if (!this.required && (!this.year && !this.month && !this.day)) {
          // It's not required and all the fields are blank
          return true
        }

        return this.isFieldValid('day') && this.isFieldValid('month') && this.isFieldValid('year')
        // TODO: Also check the number of days in this month is right.
      },
      input () {
        this.$emit('input', this.formattedDob)
      },

      inputDay (e) {
        if (this.day.length === 2) {
          this.$refs.monthElm.focus()
        } else if (this.day.length > 2 || this.day > 31) {
          this.overrideShowError = true
        }
      },

      inputMonth (e) {
        if (this.month.length === 2) {
          this.$refs.yearElm.focus()
          this.overrideShowError = false
        } else if (this.month.length > 2 || this.month > 12) {
          this.overrideShowError = true
        }
      },

      inputYear (e) {
        this.input()
        if (this.year.length > 4 || this.year > this.currentYear) {
          this.overrideShowError = true
        }
      },

      keydownDay (e) {
      },
      keydownMonth (e) {
        if (e.key === 'Backspace' && this.month === '') {
          this.$refs.dayElm.focus()
          this.$refs.dayElm.select()
          e.preventDefault()
          return false
        }
      },
      keydownYear (e) {
        if (e.key === 'Backspace' && this.year === '') {
          this.$refs.monthElm.focus()
          this.$refs.monthElm.select()
          e.preventDefault()
          return false
        }
      },
      _storeInEnquiry () {
        const enq = this.$parent.enquiryManager
        enq.setFormComponent('birthday', this)
      },

      setValue (value) {
        const dob = new Date(value)

        if (dob && isFinite(dob)) {
          this.year = dob.getFullYear()
          this.month = this.addLeadingZeros(dob.getMonth() + 1, 2)
          this.day = this.addLeadingZeros(dob.getDate(), 2)
        } else {
          this.year = ''
          this.month = ''
          this.day = ''
        }

        return this
      },

      disableElm () {
      },
      reenableElm () {
      },
      parseValueToDob (value) {
        if (value && value.indexOf('T') > -1) {
          const [datePart] = value.split('T')
          const [year, month, day] = datePart.split('-')

          this.year = year
          this.month = month
          this.day = day
        } else {
          this.year = ''
          this.month = ''
          this.day = ''
        }
      }
    },
    computed: {
      formattedDob: function () {
        return this.getValue()
      }
    },
    mounted () {
      this.parseValueToDob(this.value)
    },
    watch: {
      value: function (value) {
        this.parseValueToDob(value)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// dobSelection.vue?e4be319c